import IBranchTableData from '../../interfaces/IBranchTableData';

export interface IGetBranchModalMessage {
    branches: IBranchTableData[];
    action: ModalAction;
}

export enum ModalAction {
    reprove,
    approve,
}
